module.exports = __webpack_public_path__ + "562203b5a172956aa8a3ca717ea85d9b.jpg";